export default {
  familyName: 'Helvetica Neue',
  fullName: 'Helvetica Neue Bold',
  postscriptName: 'HelveticaNeue-Bold',
  category: 'sans-serif',
  capHeight: 714,
  ascent: 975,
  descent: -217,
  lineGap: 29,
  unitsPerEm: 1000,
  xHeight: 517,
  xWidthAvg: 480,
  subsets: {
    latin: {
      xWidthAvg: 480
    },
    thai: {
      xWidthAvg: 364
    }
  }
};
